var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline-item',{class:_vm.b(''),attrs:{"icon":_vm.iconName,"fill-dot":""}},[_c('div',{class:_vm.b('message')},[_vm._v(_vm._s(_vm.entry.message))]),_c('div',{class:_vm.b('date')},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.entry.createdAt))+" ("+_vm._s(_vm._f("timeAgo")(_vm.entry.createdAt))+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }